import React from "react";
import { Box, Collapse, Grid } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CityMap from "./cityMap";
export default function ProvinceMap(props: any) {
  const [openCollapseCity, setOpenCollapseCity] = React.useState(false);
  const [openCollapseSupp, setOpenCollapseSupp] = React.useState(false);
  const collapseCity = () => {
    setOpenCollapseCity((prev: any) => !prev);
    // setOpenCollapseSupp(false);
  };
  return (
    <>
      <Grid
        className="borderBottomDrawer mbottom15 textFont13  "
        spacing={3}
        item
        xs={12}
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item xs={4} alignItems="center" className="centerDrawerMap">
          <span style={{ color: "#73D9C4" }}>
            &nbsp; &nbsp;استان {props.province.provinceTitle}
          </span>
        </Grid>
        <Grid item xs={6} className="centerDrawerMap">
          <span style={{ color: "#fff", fontSize: "12px" }}>
            {" "}
            تعداد:&nbsp;{props.province.totalCount}&nbsp; | &nbsp; مبلغ:&nbsp;
            {props.province.totalAmount.toLocaleString("fa")} ریال
          </span>
        </Grid>
        <Grid item xs={1} onClick={collapseCity} className="centerDrawerMap">
          {openCollapseCity ? (
            <ArrowDropDownIcon fontSize="large" />
          ) : (
            <ArrowLeftIcon fontSize="large" />
          )}
        </Grid>
      </Grid>
      {props.province.cities.map((city: any) => (
        <CityMap
          city={city}
          openCollapseCity={openCollapseCity}
          openCollapseSupp={openCollapseSupp}
          setOpenCollapseSupp={setOpenCollapseSupp}
          setFlyToLoc={props.setFlyToLoc}
        />
      ))}
    </>
  );
}
